import { FragmentParagraphCarouselFragment } from '@/utils/drupal-api/__generated__/graphql';

export type CarouselProps = {
  data: FragmentParagraphCarouselFragment;
  className?: string;
  id?: string;
};

export const Carousel: React.FC<CarouselProps> = ({ data, className, id }) => {
  return (
    <section className={`paragraph-carousel ${className}`} id={id}>
      <h2>Carousel</h2>
      <pre>{JSON.stringify(data, null, 2)}</pre>
    </section>
  );
};
